import {getFocusableElements, trapFocus} from "../helpers/helper";

class StudioSearch {
    constructor(element) {
        this.body = document.querySelector('body');
        this.element = element;
        this.studioSearchBody = this.element.querySelector('.studio-search__body');
        this.toggleBtn = this.element.querySelector('.studio-search__toggle-btn button');
        if (this.toggleBtn) this.toggleBtnLabel = this.toggleBtn.querySelector('.btn__label');
        this.mapContainer = this.element.querySelector('.studio-search__map-container');
        this.toggleBtnContainer = this.element.querySelector('.studio-search__toggle-btn');

        if (this.toggleBtn) this.focusableElementsInBody = getFocusableElements(this.toggleBtnContainer);

        if (this.toggleBtn) this.toggleBtnOpenText = this.toggleBtn.dataset.openLabel;
        if (this.toggleBtn) this.toggleBtnOpenAriaText = this.toggleBtn.dataset.openAriaLabel;
        if (this.toggleBtn) this.toggleBtnCloseText = this.toggleBtn.dataset.closeLabel;
        if (this.toggleBtn) this.toggleBtnCloseAriaText = this.toggleBtn.dataset.closeAriaLabel;

        this.studioCardsInCardContainer = this.studioSearchBody.querySelectorAll('.studio-search__card-container .studio-card');
        if (this.mapContainer) this.studioCardOnMap = this.mapContainer.querySelector('.studio-card');
        if (this.studioCardOnMap) this.iconBtn = this.studioCardOnMap.querySelector('.btn.btn--icon-only');
        if (this.studioCardOnMap) this.textBtn = this.studioCardOnMap.querySelector('.studio-card__footer .btn');

        window.addEventListener('load', () => {
            this.changeToggleButtonTabIndex();
        })

        this.toggleBtn?.addEventListener('click', () => {
            this.toggleMapVisibility();
        })

        document.addEventListener('keydown', (e) => {
            if (!this.isMapShown()) return;

            trapFocus(e, () => {
                if (window.innerWidth >= 1200) {
                    return getFocusableElements(this.studioSearchBody);
                } else {
                    const mapFocusable = getFocusableElements(this.mapContainer);
                    return mapFocusable.concat(this.focusableElementsInBody);
                }
            });

            if (e.key === "Escape") {
                e.preventDefault();
                this.closeMap();
            }
        })

        window.addEventListener('resize', () => {
            this.changeToggleButtonTabIndex();

            if (window.innerWidth < 768) {
                if (this.isMapShown()) {
                    this.body.classList.add('body--not-scrollable');
                    return;
                }
            }
            this.body.classList.remove('body--not-scrollable');
        })
    }

    toggleMapVisibility() {
        if (this.isMapShown()) {
            this.closeMap();
        } else {
            this.openMap();
        }
    }

    changeToggleButtonTabIndex() {
        if (window.innerWidth >= 1200) {
            this.iconBtn?.setAttribute('tabindex', "-1");
            this.textBtn?.setAttribute('tabindex', "-1");

            this.studioCardsInCardContainer.forEach((card) => {
                let iconBtn = card.querySelector('.btn.btn--icon-only');
                iconBtn.setAttribute('tabindex', "-1");
            })

        } else {
            if (window.innerWidth >= 768) {
                this.textBtn?.removeAttribute('tabindex');
                this.iconBtn?.setAttribute('tabindex', "-1");
            } else {
                this.iconBtn?.removeAttribute('tabindex');
                this.textBtn?.setAttribute('tabindex', "-1");

                this.studioCardsInCardContainer.forEach((card) => {
                    let iconBtn = card.querySelector('.btn.btn--icon-only');
                    iconBtn.removeAttribute('tabindex');
                })
            }
        }
    }

    closeMap() {
        this.element.classList.remove('studio-search--show-map');
        this.body.classList.remove('body--not-scrollable');
        this.toggleBtnLabel.innerText = this.toggleBtnOpenText;
        this.toggleBtn.setAttribute('aria-label', this.toggleBtnOpenAriaText);
    }

    openMap() {
        this.element.classList.add('studio-search--show-map');

        if (window.innerWidth < 768) {
            this.body.classList.add('body--not-scrollable');
        }
        this.toggleBtnLabel.innerText = this.toggleBtnCloseText;
        this.toggleBtn.setAttribute('aria-label', this.toggleBtnCloseAriaText);

        this.toggleBtn.focus();
    }

    isMapShown() {
        return this.element.classList.contains('studio-search--show-map');
    }
}

export default StudioSearch;